export const CENSORSHIP_MODES = {
  BLOCK: 'block',
  MASK: 'mask',
  REMOVE: 'remove',
}

export const CENSORSHIP_MODE_OPTIONS = [
  { value: CENSORSHIP_MODES.BLOCK, label: 'Запрещать отправку' },
  { value: CENSORSHIP_MODES.MASK, label: 'Заменять звездочками' },
  { value: CENSORSHIP_MODES.REMOVE, label: 'Удалять слова' },
]

export const parseCensorshipWords = (value) => {
  if (Array.isArray(value)) {
    return normalizeCensorshipWords(value)
  }

  try {
    const parsed = value ? JSON.parse(value) : []
    return Array.isArray(parsed) ? normalizeCensorshipWords(parsed) : []
  } catch {
    return []
  }
}

export const normalizeCensorshipWords = (words = []) =>
  words
    .map((word) => String(word ?? '').trim())
    .filter(Boolean)
    .filter((word, index, arr) => (
      arr.findIndex((item) => item.toLowerCase() === word.toLowerCase()) === index
    ))

const escapeRegExp = (value = '') => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const stripHtml = (value = '') =>
  String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

export const getCensorshipMatches = (text = '', words = []) => {
  const plainText = stripHtml(text)

  return normalizeCensorshipWords(words).filter((word) => {
    const regexp = new RegExp(`(^|[^\\p{L}\\p{N}_])${escapeRegExp(word)}(?=$|[^\\p{L}\\p{N}_])`, 'iu')
    return regexp.test(plainText)
  })
}

export const applyCensorshipToText = (text = '', words = [], mode = CENSORSHIP_MODES.BLOCK) => {
  if (mode === CENSORSHIP_MODES.BLOCK) {
    return text
  }

  return normalizeCensorshipWords(words).reduce((result, word) => {
    const regexp = new RegExp(`(^|[^\\p{L}\\p{N}_])(${escapeRegExp(word)})(?=$|[^\\p{L}\\p{N}_])`, 'giu')

    return result.replace(regexp, (match, prefix, foundWord) => {
      if (mode === CENSORSHIP_MODES.REMOVE) {
        return prefix
      }

      return `${prefix}${'*'.repeat(foundWord.length)}`
    })
  }, text)
}
